import { PureComponent } from 'react';
import { Form } from 'semantic-ui-react';
import { isInteger } from 'lodash';

// COMPONENTS
import FormNumberField from 'componentsV2/Fields/numberField';
import FormSelect from 'componentsV2/Fields/selectField';

// HOCS
import withFormikInput from './withFormikInput';
import withFormField from './withFormField';

// STYLES
import styles from './Fields.styles.less';

// UTILS
import { twoDigitZeroPadTransform } from './Fields.transforms';

const timeValidator = (value) => {
  if (value.hour === '' && value.minute === '') {
    return undefined;
  }

  if (value.hour === '' || value.minute === '') {
    return { translationId: 'errors.validation.incompleteTime' };
  }

  if (!isInteger(Number(value.hour)) || !isInteger(Number(value.minute))) {
    return { translationId: 'errors.validation.onlyNumbers' };
  }

  if (Number(value.hour) > 12 || Number(value.hour) < 1) {
    return { translationId: 'errors.validation.hourOutOfBounds' };
  }

  if (Number(value.minute) > 59 || Number(value.minute) < 0) {
    return { translationId: 'errors.validation.minuteOutOfBounds' };
  }

  return undefined;
};

export class TimeField extends PureComponent {
  render() {
    // @ts-expect-error TS(2339): Property 'name' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    const { name, required, value, touched, ...rest } = this.props;

    return (
      <Form.Group name={name}>
        {/* @ts-expect-error TS(2769): No overload matches this call. */}
        <FormNumberField name={`${name}.hour`} width={5} {...rest} blurTransform={twoDigitZeroPadTransform} fluid />
        <span className={styles['time-field__separator']}>:</span>
        {/* @ts-expect-error TS(2769): No overload matches this call. */}
        <FormNumberField name={`${name}.minute`} width={5} {...rest} blurTransform={twoDigitZeroPadTransform} fluid />
        <FormSelect
          className={styles['period-select']}
          name={`${name}.period`}
          options={[
            {
              id: 'am',
              value: 'am',
              label: 'am',
            },
            {
              id: 'pm',
              value: 'pm',
              label: 'pm',
            },
          ]}
          width={6}
          {...rest}
          // @ts-expect-error TS(2769): No overload matches this call.
          showSelected
          button
        />
      </Form.Group>
    );
  }
}

const _TimeField = withFormField(TimeField);

const FormTimeField = withFormikInput(_TimeField, {
  validators: [timeValidator],
  passProps: ['touched'],
});

export default FormTimeField;
